<template>
  <div class="d-flex align-items-start flex-column">
    <div class="d-flex flex-column">
      <a
        v-for="(action, index) in device.actions"
        :key="index"
        href="#"
        @click.prevent="handleClick(action)"
        style="margin-bottom: 5px"
        class="dmp-zone-action"
      >
      </a>
    </div>

    <!-- Modo mantenimiento -->
    <b-form-checkbox
      :id="`maintenance-zone-${device.id}`"
      :checked="maintenanceValue"
      :disabled="!device.device_proxy_id"
      :title="device.device_proxy_id ? null : 'Falta el ID de dispositivo de la zona'"
      switch
      class="maintenance-check"
      @change="onMaintenanceChange"
    >
      <small>Modo mantenimiento</small>
    </b-form-checkbox>
  </div>
</template>

<script>
import { ref } from "@vue/composition-api";
import { useDeviceMessages } from "@/views/dmp/dmp_panels/devices/composables/useDeviceMessages";
import axios from "@axios";

export default {
  name: "DmpZone",
  props: {
    device: Object,
    trans: Object,
    loadingToast: Object,
    updateStatus: Function,
    maintenanceValue: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { confirmActionAlert, successAlertAction, errorAlertAction, showToast } =
      useDeviceMessages(props.trans);
    const localLoading = ref(false);

    const handleClick = async (action) => {
      const result = await confirmActionAlert(props.device, action);

      if (!result.isConfirmed) return;

      localLoading.value = true;
      showToast(props.device.status, props.device, props.loadingToast);

      try {
        const urlAction = action.data.url;

        await axios.get(urlAction);

        props.updateStatus();

        successAlertAction(props.device, action);
      } catch (error) {
        console.error(
          `error in request for device ${props.device.text}:`,
          JSON.stringify(error)
        );
        errorAlertAction(props.device.status, error.response?.data?.message);
      } finally {
        localLoading.value = false;
        if (props.loadingToast) props.loadingToast.close();
      }
    };

    const onMaintenanceChange = (value) => {
      if (!props.device.device_proxy_id) return;
      emit("maintenance-toggle", {
        type: props.device.device_type,
        device: props.device,
        value,
      });
    };

    return { handleClick, localLoading, onMaintenanceChange };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables/_variables.scss";
.dmp-zone-action {
  .dark-layout & {
    color: $theme-dark-headings-color;
    &:hover {
      color: $theme-dark-label-color;
    }
  }
}
.maintenance-check {
  white-space: nowrap;
}
</style>
